module.exports = __webpack_public_path__ + "static/img/speed-up-s.d4c858c3.png";